import CustomIcon from './CustomIcon'
import black from '../../../assets/img/icons/aurora.black.svg'
import white from '../../../assets/img/icons/aurora.white.svg'

const AuroraIcon = (props: any) => {
    return (
        <CustomIcon
            light={black}
            dark={white}
            size={props.size} />
    );
};

export default AuroraIcon;